import IconButton from '@mui/material/IconButton';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import { format } from 'date-fns';
import { ReactElement } from 'react';

import { compareYearMonth, firstDayOf, IYearMonth, shiftYearMonth } from '~/utils/date/date';

import styles from './PlanEngagement.module.scss';

interface IMonthBarProps {
  selected: IYearMonth;
  last: IYearMonth;
  onChange: (month: IYearMonth) => void;
}

const MonthBar = ({ selected, last, onChange }: IMonthBarProps): ReactElement => {
  const monthStart = firstDayOf(selected);

  return (
    <div className={styles.monthBar}>
      <h3 className={styles.monthLabel}>
        <span className={styles.month}>{format(monthStart, 'MMM')}</span>{' '}
        <span>{format(monthStart, 'yyyy')}</span>
      </h3>
      <div className={styles.monthArrows}>
        <IconButton
          aria-label="Previous month"
          size="small"
          onClick={() => onChange(shiftYearMonth(selected, -1))}
          className={styles.monthArrow}
        >
          <ChevronLeft />
        </IconButton>
        <IconButton
          aria-label="Next month"
          size="small"
          disabled={compareYearMonth(selected, last) >= 0}
          onClick={() => onChange(shiftYearMonth(selected, 1))}
          className={styles.monthArrow}
        >
          <ChevronRight />
        </IconButton>
      </div>
    </div>
  );
};

export default MonthBar;
